import { Injectable, inject } from '@angular/core';
import { webApi, webDtos } from '@vectronic/openApi-customer';
import { RmaDeviceNetworkStatusService, RmaSide, rmaDeviceIds } from '@vectronic/util';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class CustomerRmaDeviceNetworkStatusService extends RmaDeviceNetworkStatusService {
  private collarsApi = inject(webApi.Collars);

  loadForRma(rma: RmaSide) {
    const deviceIds = rmaDeviceIds(rma);
    if (!deviceIds.length) return;
    this.collarsApi
      .getDataWithAggregatedInformation(false, false, deviceIds)
      .pipe(catchError(() => of<webDtos.CollarExtended[]>([])))
      .subscribe((devices) => this.setStatuses(devices));
  }
}
